import Vue from "vue";
import Router from "vue-router";


Vue.use(Router);
// Vue.use(window.VueRouter)
// console.log(Router)
export default new Router({
  // export default new window.VueRouter({
  routes: [
    {
      path: "/login",
      name: "login",
      component: resolve => require(['../components/Login/login.vue'], resolve),
      meta: { keepAlive: false, title: "登录" },
    },
    {
      path: "/",
      component: resolve => require(['../components/Home/home.vue'], resolve),
      redirect: "/indexpage",
      meta: { keepAlive: false, title: "模板" },
      children: [
        {
          path: "/indexpage",
          component: resolve => require(['../components/IndexPage/indexpage.vue'], resolve),
          meta: { keepAlive: false, title: "首页" }
        },
        {
          path: "/report",
          meta: { keepAlive: false, title: "巡检报表管理" },
          component: resolve => require(['../components/InpsecReport/report.vue'], resolve)

        },
        {
          path: "/chart",
          meta: { keepAlive: false, title: "图表分析" },
          component: resolve => require(['../components/Chart/chart.vue'], resolve)

        },
        {
          path: "/devicegroup",
          component: resolve => require(['../components/UserManage/DeviceGroup/devicegroup.vue'], resolve),
          meta: { keepAlive: false, title: "班组管理" }
        },
        {
          path: "/missed_details",
          component: resolve => require(['../components/Missed_Details/missed_details.vue'], resolve),
          meta: { keepAlive: false, title: "漏检详情查看" }
        },
        {
          path: "/teamcomp",
          component: resolve => require(['../components/Teamcomp/teamcomp.vue'], resolve),
          meta: { keepAlive: false, title: "班组完成情况" }
        },

        {
          path: "/rolemanage",
          component: resolve => require(['../components/UserManage/RoleMangage/rolemanage.vue'], resolve),
          meta: { keepAlive: false, title: "角色管理" }
        },
        {
          path: "/sitemanage",
          component: resolve => require(['../components/UserManage/SiteManage/sitemanage.vue'], resolve),
          meta: { keepAlive: false, title: "楼宇管理" }
        },
        {
          path: "/persioninfo",
          component: resolve => require(['../components/UserManage/Persioninfo/persioninfo.vue'], resolve),
          meta: { keepAlive: false, title: "个人信息" }
        },
        {
          path: "/jurisdiction",
          component: resolve => require(['../components/UserManage/Jurisdic/jurisdiction.vue'], resolve),
          meta: { keepAlive: false, title: "权限管理" }
        },
        {
          path: "/landmarkconfig",
          component: resolve => require(['../components/UserManage/LandmarkConfig/landmarkconfig.vue'], resolve),
          meta: { keepAlive: false, title: "地标配置" }
        },
        {
          path: "/updatepasswordtime",
          component: resolve => require(['../components/UserManage/UpdatePasswordTime/updatepasswordtime.vue'], resolve),
          meta: { keepAlive: false, title: "地标配置" }
        },
        {
          path: "/devicelist",
          component: resolve => require(['../components/DeviceManage/DeviceList/devicelist.vue'], resolve),
          meta: { keepAlive: false, title: "设备台账" }
        },
        {
          path: "/devicement",
          component: resolve => require(['../components/DeviceManage/DeviceMent/devicement.vue'], resolve),
          meta: { keepAlive: false, title: "设备维修台账" }
        },
        {
          path: "/devicetype",
          component: resolve => require(['../components/DeviceManage/DeviceType/devicetype.vue'], resolve),
          meta: { keepAlive: false, title: "设备类型" }
        },
        {
          path: "/deviceparm",
          component: resolve => require(['../components/DeviceManage/DeviceParm/deviceparm.vue'], resolve),
          meta: { keepAlive: false, title: "设备参数" }
        },
        {
          path: "/inpsecrecord",
          component: resolve => require(['../components/InpsecRecord/inpsecrecord.vue'], resolve),
          meta: { keepAlive: false, title: "巡检记录" }
        },
        {
          path: "/takemedi",
          meta: { keepAlive: false, title: "巡检任务" },
          component: resolve => require(['../components/takemedi/takemedi.vue'], resolve)
        },
        {
          path: "/historydata",
          meta: { keepAlive: false, title: "历史数据备份" },
          component: resolve => require(['../components/HistoryData/historydata.vue'], resolve)
        },
        {
          path: "/clearreservoir",
          meta: { keepAlive: false, title: "历史数据备份" },
          component: resolve => require(['../components/ClearReservoir/clearreservoir.vue'], resolve)
        }, {
          path: "/clearData",
          meta: { keepAlive: false, title: "垃圾清理" },
          component: resolve => require(['../components/ClearData/clearData.vue'], resolve)
        },

        {
          path: "/userinformationmanage",
          component: resolve => require(['../components/UserManage/UserinformationManage/userinformationmanage.vue'], resolve),
          meta: { keepAlive: false, title: "用户信息管理" }
        },
        {
          path: "/assetsaccount",
          component: resolve => require(['../components/Assets/assetsaccount/assetsaccount.vue'], resolve),
          meta: { keepAlive: false, title: "资产台账" }
        },
        {
          path: "/assetsstatement",
          component: resolve => require(['../components/Assets/assetsstatement/assetsstatement.vue'], resolve),
          meta: { keepAlive: false, title: "资产列表" }
        }
        ,
        {
          path: "/abnormalreport",
          component: resolve => require(['../components/ReportForm/AbnormalReport/abnormalreport.vue'], resolve),
          meta: { keepAlive: false, title: "异常设备列表" }
        },
        {
          path: "/missedreport",
          component: resolve => require(['../components/ReportForm/MissedReport/missedreport.vue'], resolve),
          meta: { keepAlive: false, title: "漏检设备列表" }
        },
        {
          path: "/coreindex",
          component: resolve => require(['../components/CoreIndex/coreindex.vue'], resolve),
          meta: { keepAlive: false, title: "首页" }
        },
        {
          path: "/middlepersonal",
          component: resolve => require(['../components/MiddlePersonal/middlepersonal.vue'], resolve),
          meta: { keepAlive: false, title: "个人信息" }
        }
      ]
    }
  ],
  mode: "history"
});





// WEBPACK FOOTER //
// ./src/router/index.js